import React from "react";
import "./Home.css";
import { Container, Row, Col } from "react-bootstrap";
import logoblk from '../img/logo-blk.png';
import productsdataplatform from '../img/products-data-platform.png';
import CheckAppVersion from "../components/CheckAppVersion";

export default function Home() {
  return (
    <Container className="Home">
      <CheckAppVersion/>
      <div className="hero">
        <Container className="tagline" fluid>
          <Row>
            <Col>
              <div className="w-600">
                <h1>Location intelligence for planetary missions.</h1>
                <p>Traverse with confidence.</p>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="godown"></div>
      </div>
      <Container className="vision" fluid>
        <div className="w-500">
          <Row>
            <Col>
              <h1>Our Vision</h1>
              <p>Geedop enables missions with spatial processing models, analytics, and hardware integrations for surface mobility.</p>
            </Col>
          </Row>
        </div>
      </Container>
      <Container className="products" fluid>
        <div className="w-500">
          <Row>
            <Col md={2}></Col>
            <Col md={8}>
              <div className="dataplatform">
                <img src={productsdataplatform} alt="" />
              </div>
              <div className="launchsoon">
                <span className="pill">We're launching soon</span>
                <p className="joinwaitlist">Get in touch with us below and we'lll reach out with updates.</p>
              </div>
            </Col>
            <Col md={2}></Col>
          </Row>
        </div>
      </Container>
      <Container className="frames pair" fluid>
        <Row>
          <Col md={6} className="left text">
            <div className="inner">
              <h2>Reference Frames</h2>
              <p>Interactive design of accurate distance measurement systems for landing site planning and surface mobility.</p>
            </div>
          </Col>
          <Col md={6} className="right image">
            <div className="inner"></div>
          </Col>
        </Row>
      </Container>
      <Container className="maps pair" fluid>
        <Row>
          <Col md={6} className="left image">
            <div className="inner"></div>
          </Col>
          <Col md={6} className="right text">
            <div className="inner">
              <h2>Maps</h2>
              <p>Spatial analyses pipelines for terrain traversability.</p>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="hardware pair" fluid>
        <Row>
          <Col md={6} className="left text">
            <div className="inner">
              <h2>Surface Navigation</h2>
              <p>Hardware systems to fuse map and sensor data, enabling rovers to navigate through varying surface types.</p>
            </div>
          </Col>
          <Col md={6} className="right image">
            <div className="inner"></div>
          </Col>
        </Row>
      </Container>
      <Container className="prefoot" fluid>
        <Row>
          <Col md={6} className="left">
            <div className="logoblk">
              <img src={logoblk} alt="" />
            </div>
            <div>
              <p className="reach">Feel free to reach out if you're interested in working with us.</p>
            </div>
            <div className="emaillink">
              <a href="mailto:spatial@geedop.us">spatial@geedop.us</a>
            </div>
          </Col>
          <Col md={2}></Col>
          <Col md={4} className="contact right">
            <h5>Contact us</h5>
            <p className="p mb-0">11450 James Watt Dr Ste B7</p>
            <p className="p">El Paso, TX 79936, United States <br/><a href="https://goo.gl/maps/Hn23N6kp8ETy8RBe7" target="_blank" rel="noopener noreferrer">Directions</a></p>
            <p className="p mt-0 mb-0">+1 915 599 9939</p>
            <p><a className="action" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/geedopspatial/">LinkedIn</a></p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}